import { lazy } from "react";

export const AccountsList = lazy(() => import("../pages/Accounts/AccountsList"));
export const AccountView = lazy(() => import("../pages/Accounts/AccountView"));
export const Login = lazy(() => import("../pages/Auth/Login"));
export const Dashboard = lazy(() => import("../pages/Dashboard/View/Dashboard"));
export const StaffProfile = lazy(() => import("../pages/Staff/Profile"));
export const StaffProfileView = lazy(() => import("../pages/Staff/ProfileView"));
export const CustomersList = lazy(() => import("../pages/Customers/CustomersList"));
export const CustomerView = lazy(() => import("../pages/Customers/CustomerView"));
export const DriversList = lazy(() => import("../pages/Drivers/DriversList"));
export const DriverView = lazy(() => import("../pages/Drivers/DriverView"));
export const BookingsList = lazy(() => import("../pages/Bookings/BookingsList"));
export const BookingView = lazy(() => import("../pages/Bookings/BookingView"));
export const BookingActionsView = lazy(() => import("../pages/Bookings/BookingActionsView"));
export const EditBooking = lazy(() => import("../pages/Bookings/EditBooking"));
export const CreateBooking = lazy(() => import("../pages/Bookings/CreateBooking"));
export const CreateSchedule = lazy(() => import("../pages/Schedules/CreateSchedule"));
export const EditSchedule = lazy(() => import("../pages/Schedules/EditSchedule"));
export const MassEditBookings = lazy(() => import("../pages/Schedules/MassEditBookings"));
export const ScheduleView = lazy(() => import("../pages/Schedules/ScheduleView"));
export const ScheduleActionsView = lazy(() => import("../pages/Schedules/ScheduleActionsView"));
export const SchedulesList = lazy(() => import("../pages/Schedules/SchedulesList"));
export const Regions = lazy(() => import("../pages/Regions"));
export const AuthorityView = lazy(() => import("../pages/LocalAuthorities/LocalAuthorityView"));
export const ConfigManagement = lazy(() => import("../pages/ConfigManagement"));
export const LiveMap = lazy(() => import("../pages/LiveMap"));
export const AuditLogs = lazy(() => import("../pages/AuditLogs"));
export const Notifications = lazy(() => import("../pages/Notifications"));
export const NotificationsV2 = lazy(() => import("../pages/NotificationsV2"));
export const Finance = lazy(() => import("../pages/Finance"));
export const IntercomTest = lazy(() => import("../pages/IntercomTest"));
export const AuthManagement = lazy(() => import("../pages/AuthManagement"));

export const LiveLogs = lazy(() => import("../pages/LiveLogs"));
export const RideMatchingMonitor = lazy(() => import("../pages/RideMatchingMonitor"));
export const GhostDocuments = lazy(() => import("../pages/DevTools/GhostDocuments"));
export const DataMigration = lazy(() => import("../pages/DevTools/DataMigration"));
export const FleetOverview = lazy(() => import("../pages/Drivers/FleetOverview/FleetOverviewEnhanced"));
export const OrganizationManagement = lazy(() => import("../pages/OrganizationManagement"));
export const TestNotifications = lazy(() => import("../pages/TestNotifications"));
export const CustomerSupport = lazy(() => import("../pages/CustomerSupport"));
export const AuditTest = lazy(() => import("../pages/SystemAdmin/AuditTest"));
export const FixDriverAliases = lazy(() => import("../pages/SystemAdmin/FixDriverAliases"));
export const PersonalAssistantsList = lazy(() => import("../pages/PersonalAssistants/PersonalAssistantsList"));
export const PersonalAssistantView = lazy(() => import("../pages/PersonalAssistants/PersonalAssistantView"));
export const B2BList = lazy(() => import("../pages/B2B/B2BList"));
export const B2BView = lazy(() => import("../pages/B2B/B2BView"));
